import PaymentNotificationSettingForm from "../PaymentNotificationParameterForm";
import SalesNotificationSettingForm from "../SalesNotificationParameterForm";
import SalesPartitionSettingForm from "../SalesPartitionParameterForm";

const PRINT_PARAMETER_FORMS = {
  3: SalesNotificationSettingForm,
  5: SalesPartitionSettingForm,
  6: PaymentNotificationSettingForm,
  13: SalesNotificationSettingForm,
  'default': () => null,
};

export default PRINT_PARAMETER_FORMS;